import {React, useState} from 'react';
import HeaderSection from "../headerSection/HeaderSection";
import './VicariousPilgrimageStyle.scss'
import {useForm} from 'react-hook-form';
import {ErrorMessage} from '@hookform/error-message';
import ziaratImage from '../../assets/images/ziarat.jpg';
import leftBorder from '../../assets/images/topborder.svg';
import rightBorder from '../../assets/images/topborder.svg';
import axios from 'axios';
import {ToastContainer, toast} from 'react-toastify';
import axiosServise from '../ApiService';
import HadisBox from "../HadisBox/HadisBox.tsx";

function VicariousPilgrimage() {
    const {register, formState: {errors}, watch, handleSubmit} = useForm();
    const onSubmit = data => {
        axiosServise.post('VicariousPilgrimages', data)
            .then(response =>
                toast.success(response.data.message, {
                    position: "bottom-right",
                    autoClose: 5000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                    theme: "colored",
                })
            )
            .catch(error => {
                toast.error(error.data.message, {
                    position: "bottom-right",
                    autoClose: 5000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                    theme: "colored",
                });
            });
    }


    //برای چک کردن فیلد که برای خود یا دیگری استت
    const behalf = watch("VicariousType");

    const cities = [
        {
            "id": 0,
            "name": "",
        },
        {
            "id": 1,
            "name": "آذربایجان شرقی",
        },
        {
            "id": 2,
            "name": "آذربایجان غربی",
        },
        {
            "id": 3,
            "name": "اردبیل",
        },
        {
            "id": 4,
            "name": "اصفهان",
        },
        {
            "id": 5,
            "name": "البرز",
        },
        {
            "id": 6,
            "name": "ایلام",
        },
        {
            "id": 7,
            "name": "بوشهر",
        },
        {
            "id": 8,
            "name": "تهران",
        },
        {
            "id": 9,
            "name": "چهارمحال و بختیاری",
        },
        {
            "id": 10,
            "name": "خراسان جنوبی",
        },
        {
            "id": 11,
            "name": "خراسان رضوی",
        },
        {
            "id": 12,
            "name": "خراسان شمالی",
        },
        {
            "id": 13,
            "name": "خوزستان",
        },
        {
            "id": 14,
            "name": "زنجان",
        },
        {
            "id": 15,
            "name": "سمنان",
        },
        {
            "id": 16,
            "name": "سیستان و بلوچستان",
        },
        {
            "id": 17,
            "name": "فارس",
        },
        {
            "id": 18,
            "name": "قزوین",
        },
        {
            "id": 19,
            "name": "قم",
        },
        {
            "id": 20,
            "name": "کردستان",
        },
        {
            "id": 21,
            "name": "کرمان",
        },
        {
            "id": 22,
            "name": "کرمانشاه",
        },
        {
            "id": 23,
            "name": "کهگیلویه و بویراحمد",
        },
        {
            "id": 24,
            "name": "گلستان",
        },
        {
            "id": 25,
            "name": "لرستان",
        },
        {
            "id": 26,
            "name": "گیلان",
        },
        {
            "id": 27,
            "name": "مازندران",
        },
        {
            "id": 28,
            "name": "مرکزی",
        },
        {
            "id": 29,
            "name": "هرمزگان",
        },
        {
            "id": 30,
            "name": "همدان",
        },
        {
            "id": 31,
            "name": "یزد",
        }
    ]

    return (
        <div className='vicarious-Page'>
            <HeaderSection></HeaderSection>
            <div className='body-vicariousPage'>
                <div className='Vicarious-box'>
                    <form onSubmit={handleSubmit(onSubmit)} className='Vicarious-form'>
                        <div className='border-form'>
                            <img src={rightBorder} className="right-border" alt=""/>
                        </div>

                        <div className="mb-3 d-column">
                            <label className="form-label">نام :</label>
                            <input className='form-control' type="text" placeholder="نام" {...register("FirstName", {
                                required: "این فیلد الزامی میبشد",
                                maxLength: 30,
                                pattern: {
                                    value: /^[\u0600-\u06FF\s]+$/,
                                    message: "لطفا نام فارسی خود را وارد نمایید",
                                },
                            })} />
                            <ErrorMessage errors={errors}
                                          name="FirstName"
                                          render={({message}) => <span className='erore-massage'>{message}</span>}
                            />
                        </div>

                        <div className="mb-3 d-column">
                            <label className="form-label">نام خانوادگی :</label>
                            <input className='form-control' type="text"
                                   placeholder="نام خانوادگی" {...register("LastName", {
                                required: "این فیلد الزامی میبشد",
                                maxLength: 30,
                                pattern: {
                                    value: /^[\u0600-\u06FF\s]+$/,
                                    message: "لطفا نام فارسی خود را وارد نمایید",
                                },
                            })} />
                            <ErrorMessage errors={errors}
                                          name="LastName"
                                          render={({message}) => <span className='erore-massage'>{message}</span>}
                            />
                        </div>

                        <div className="mb-3 d-column">
                            <label className="form-label ">استان محل سکونت :</label>
                            <select
                                className='form-select form-control' {...register("FromProvince", {required: "این فیلد الزامی میبشد"})}>
                                {cities.map(city => {
                                    return (<option className='form-control' value={city.name} key={city.id}>{city.name}
                                        </option>
                                    )
                                })}
                            </select>
                            <ErrorMessage errors={errors}
                                          name="FromProvince"
                                          render={({message}) => <span className='erore-massage'>{message}</span>}
                            />
                        </div>

                        <div className="mb-3 d-column">
                            <label className="form-label">شماره موبایل :</label>
                            <input className='form-control' type="text"
                                   placeholder="شماره موبایل" {...register("Mobile", {
                                required: "این فیلد الزامی میبشد",
                                maxLength: 11,
                                pattern: {
                                    value: /^[0][9][0-9][0-9]{8,8}$/,
                                    message: 'فرمت شماره موبایل  باید ****09 باشد.',
                                },
                            })} />
                            <ErrorMessage errors={errors}
                                          name="Mobile"
                                          render={({message}) => <span className='erore-massage'>{message}</span>}
                            />
                        </div>

                        <div className="mb-3 d-column">
                 <textarea
                     className='form-control textareaStyle'
                     type="text"
                     placeholder="توضیحات ..."
                     name="content"
                     {...register("Description", {required: false, maxLength: 1000})}
                 />
                        </div>

                        <div className='mb-3 d-column'>
                            <span className='form-label'>به نیالت از :</span>
                            <div>
                                <label className='form-label'>خودم</label>
                                <input className='behalf-input' {...register("VicariousType", {required: true})}
                                       type="radio" value="1"/>
                            </div>
                            <div>
                                <label className='form-label'>دیگران</label>
                                <input className='behalf-input'
                                       style={{left: '6.4px'}} {...register("VicariousType", {required: true})}
                                       type="radio" value="2"/>
                            </div>
                        </div>

                        {behalf === '2' &&
                            <div className="mb-3 d-column">
                                <label className="form-label">نام و نام خانودگی شخص :</label>
                                <input className='form-control' type="text"
                                       placeholder="نام" {...register("fristName", {
                                    required: "این فیلد الزامی میبشد",
                                    maxLength: 30,
                                    pattern: {
                                        value: /^[\u0600-\u06FF\s]+$/,
                                        message: "لطفا نام فارسی خود را وارد نمایید",
                                    },
                                })} />
                                <ErrorMessage errors={errors}
                                              name="fristName"
                                              render={({message}) => <span className='erore-massage'>{message}</span>}
                                />
                            </div>

                        }
                        <input type="submit" value='ارسال' className='submit'/>

                        <div className='border-form'>
                            <img src={leftBorder} className="left-border" alt=""/>
                        </div>

                    </form>


                </div>
                <div className='Vicarious-information'>
                    <h5>زیارت نیابتی حرم امازاده جعفر</h5>
                    <br/>
                    <p>برای انجام زیارت نیابتی از طرف خادمین محترم حرم برای شما لطفا اطلاعات این فرم را پر کنید.</p>
                    <p>با پر کردن این اطلاعات شما به دست خادمین محترم میرسد و خادمین محترم میتوانند زیارت را انجام
                        دهند.</p>
                    <h5>نکته:</h5>
                    <p>زائر محترم همچنین شما میتوانید با انتخاب دکمه به نیت از دیگران جای فردی دیگر زیارت نیابتی خود را
                        ثبت کنید.</p>
                    <p>در صورتی که زیارت شما انجام شود پیامک زیارت نیابتی شما که انجام شده است باید به اطلاع شما
                        میرسد.</p>
<HadisBox>
    <img src={rightBorder} className="hadis-border" alt=""/>
    <div className='hadis-box'>
        <h6>حضرت امام صادق (ع) فرمود:</h6>
        <span>هر کس ما را پس از وفاتمان زیارت کند، گویا ما را در حال حیات، زیارت کرده است.</span>
    </div>
    <img src={leftBorder} className="left-border hadis-border" alt=""/>
</HadisBox>



                </div>


            </div>
            <ToastContainer
                position="bottom-right"
                autoClose={5000}
                hideProgressBar={false}
                newestOnTop={false}
                closeOnClick
                rtl={false}
                pauseOnFocusLoss
                draggable
                pauseOnHover
                theme="colored"
            />
        </div>
    )
}

export default VicariousPilgrimage;